import React, { useRef, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useContact } from '../../context/ContactContext'
import './contact.css'
import { MdOutlineEmail } from 'react-icons/md'
import { RiMessengerLine } from 'react-icons/ri'
import { BsWhatsapp } from 'react-icons/bs'
import { FiX } from 'react-icons/fi'
import emailjs from 'emailjs-com'

const ContactModal = () => {
  const { t } = useTranslation()
  const { isOpen, closeContact } = useContact()
  const form = useRef()
  const [sent, setSent] = useState(false)

  useEffect(() => {
    if (!isOpen) return undefined

    document.body.style.overflow = 'hidden'

    const onKey = (e) => {
      if (e.key === 'Escape') closeContact()
    }
    window.addEventListener('keydown', onKey)
    return () => {
      document.body.style.overflow = ''
      window.removeEventListener('keydown', onKey)
    }
  }, [isOpen, closeContact])

  if (!isOpen) return null

  const sendEmail = (e) => {
    e.preventDefault()
    emailjs.sendForm('service_rbeqq9w', 'template_4vg1mho', form.current, '4lfi3TopbaazF6Fuo')
      .then(() => {
        setSent(true)
        e.target.reset()
        setTimeout(() => setSent(false), 4000)
      })
  }

  const channels = [
    { icon: MdOutlineEmail, label: t('contact.email'), value: 'info@unicodes.dev', href: 'mailto:info@unicodes.dev' },
    { icon: RiMessengerLine, label: t('contact.messenger'), value: 'unicodes.dev', href: 'https://m.me/unicodes.dev' },
    { icon: BsWhatsapp, label: t('contact.whatsapp'), value: '+389 71 637 776', href: 'https://api.whatsapp.com/send?phone=+38971637776' },
  ]

  return (
    <div className="contact-modal__overlay" onClick={closeContact} role="presentation">
      <div
        className="contact-modal glass"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="contact-modal-title"
      >
        <button type="button" className="contact-modal__close" onClick={closeContact} aria-label="Close">
          <FiX />
        </button>

        <div className="contact-modal__header">
          <span className="section__label">{t('contact.subtitle')}</span>
          <h2 id="contact-modal-title">{t('contact.title')}</h2>
        </div>

        <div className="contact__layout contact-modal__body">
          <div className="contact__channels">
            {channels.map(({ icon: Icon, label, value, href }) => (
              <a key={label} href={href} className="contact__channel glass" target="_blank" rel="noopener noreferrer">
                <div className="contact__channel-icon"><Icon /></div>
                <div>
                  <span className="contact__channel-label">{label}</span>
                  <strong>{value}</strong>
                </div>
              </a>
            ))}
          </div>

          <form ref={form} onSubmit={sendEmail} className="contact__form glass">
            <input type="text" name="name" placeholder={t('contact.namePlaceholder')} required />
            <input type="email" name="email" placeholder={t('contact.emailPlaceholder')} required />
            <textarea name="message" rows="5" placeholder={t('contact.messagePlaceholder')} required></textarea>
            <button type="submit" className="btn btn-primary">{t('contact.submit')}</button>
            {sent && <p className="contact__success">{t('contact.success')}</p>}
          </form>
        </div>
      </div>
    </div>
  )
}

export default ContactModal
